import React, { Component } from "react";
import styles from "./index.less";

interface Props {
  buttonText: string;
  type?: string;
  styleColor?: string;
  grayType?: boolean;
  buttonClick?: () => void;
}

class GeneralButton extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }
  render() {
    const { buttonText, type, buttonClick, styleColor, grayType } = this.props;
    return (
      <div
        className={styles.generalButton}
        style={{ pointerEvents: grayType||buttonText==='提交中...' ? "none" : null ,textAlign:'center'}}
        onClick={buttonClick}
      >
        <button
          className={
            styleColor === "activation"
              ? grayType
                ? styles.grayType
                : styles.activation
              : styles.unactivation
          }
          style={{
            width:
              type === "small"
                ? "100px"
                : type === "middle"
                ? "200px"
                : "320px",
          }}
        >
          {buttonText}
        </button>
      </div>
    );
  }
}
export default GeneralButton;
